var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.117 2.5a4.214 4.214 0 0 1 4.218 4.208v6.584a4.215 4.215 0 0 1-4.218 4.208H5.885a4.214 4.214 0 0 1-4.217-4.208V6.708A4.209 4.209 0 0 1 5.885 2.5h8.232zm.943 4.333a.633.633 0 0 0-.468.167l-3.757 3c-.484.4-1.176.4-1.667 0l-3.75-3a.634.634 0 0 0-.833.058.637.637 0 0 0-.06.834l.11.108 3.791 2.958a2.62 2.62 0 0 0 3.258 0l3.759-3.008.067-.067c.199-.241.199-.591-.01-.833a.7.7 0 0 0-.44-.217z",
    fill: "#4CA1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.2678a1308e7d0d44eb3a1564fadf4260.svg";
export { ForwardRef as ReactComponent };